import { useGameStore } from '@campus/core';
import { Icon } from '../ds/index.js';
import { retryRealtimeNow } from '../../bridge/GameBridge.js';

/**
 * Bandeau « Connexion perdue » — reconnexion automatique du temps réel en
 * cours (GameBridge, realtimeStatus). Monté au niveau de l'app pour rester
 * visible depuis l'administration, qui garde le campus connecté derrière elle.
 */
export function ConnectionBanner() {
  const status = useGameStore((s) => s.realtimeStatus);
  if (status === 'connected') return null;

  const failed = status === 'failed';
  return (
    <div
      role="status"
      aria-live="polite"
      className="pl-hud pl-connection-banner"
    >
      <span className="pl-connection-banner-text">
        <span aria-hidden className={failed ? undefined : 'pl-connection-banner-spin'}>
          <Icon name={failed ? 'alert' : 'refresh'} size={16} />
        </span>
        {failed
          ? 'Connexion au campus impossible.'
          : 'Connexion perdue, reconnexion…'}
      </span>
      {failed && (
        <>
          <span className="pl-hud-sep" />
          <button type="button" className="pl-hud-btn" onClick={() => retryRealtimeNow()}>
            Réessayer
          </button>
          <button type="button" className="pl-hud-btn" onClick={() => window.location.reload()}>
            <Icon name="refresh" size={16} />Recharger
          </button>
        </>
      )}
    </div>
  );
}
